import { Separator } from "@/components/ui/separator";

export type RecipeReadOnlyContentProps = Readonly<{
  directions: string[];
  notes?: string | null;
}>;

export const RecipeReadOnlyContent = ({ directions, notes }: RecipeReadOnlyContentProps) => {
  return (
    <article className="space-y-8">
      <div>
        <h2 className="font-headline text-2xl font-semibold">Directions</h2>
        <Separator className="my-3" />
        <div className="space-y-4 text-foreground">
          {directions.length > 0 ? (
            directions.map((step) => {
              const normalized = step.trim().toLowerCase();
              const key = normalized || `step-${step.length}`;

              return (
                <p key={key} className="leading-relaxed">
                  {step}
                </p>
              );
            })
          ) : (
            <p className="text-muted-foreground">No directions yet.</p>
          )}
        </div>
      </div>

      {notes ? (
        <div>
          <h2 className="font-headline text-2xl font-semibold">Notes</h2>
          <Separator className="my-3" />
          <p className="italic text-muted-foreground">{notes}</p>
        </div>
      ) : null}
    </article>
  );
};

